import styled from '@emotion/styled';
import { colors, spacing } from '../../../themes';

type CardContainerProps = {
  highlighted?: boolean;
  accentColor?: string;
};

export const CardContainer = styled.div<CardContainerProps>`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: min(420px, 100%);
  background: ${colors.base.white};
  border: 1.01px solid #e5eaf0;
  border-radius: 8px;
  box-shadow: 0 7px 14px 0 rgba(0, 0, 0, 0.08);
  transition: all 0.2s ease;
  overflow: hidden;

  ${({ highlighted }) =>
    highlighted &&
    `
    transform: scale(1.02);
  `}
`;

type HeaderSectionProps = {
  highlighted?: boolean;
  accentColor?: string;
};

export const HeaderSection = styled.div<HeaderSectionProps>`
  padding: ${spacing.mediumLow} ${spacing.mediumLow};
  font-size: 24px;
  font-weight: 700;
  display: flex;
  flex-direction: column;
  gap: ${spacing.xxsmall};
  align-self: stretch;
  border-radius: 8px 8px 0 0;
  background: ${({ highlighted, accentColor }) =>
    highlighted ? accentColor || colors.primary.blue : colors.monochrome.grey10};

  & h4 {
    font-weight: 700;
    line-height: 28px;
    letter-spacing: 2px;
    text-transform: uppercase;
  }
`;

export const FeaturesSection = styled.div`
  padding: ${spacing.small};
  flex: 1;
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: ${spacing.xsmall};
`;

export const FeatureItem = styled.div<{ included: boolean }>`
  display: flex;
  align-items: flex-start;
  gap: ${spacing.xxsmall};
  opacity: ${({ included }) => (included ? 1 : 0.5)};
`;

export const FeatureIconWrapper = styled.div`
  flex-shrink: 0;
  margin-top: 2px;
`;

export const PriceSection = styled.div`
  padding: ${spacing.small};
  display: flex;
  width: 100%;
  flex-direction: column;
  gap: ${spacing.xxsmall};
`;

export const PriceAmount = styled.div`
  display: flex;
  align-items: baseline;
  gap: ${spacing.tiny};
`;

export const ButtonSection = styled.div`
  padding: ${spacing.small} 0;
  border-top: 1.01px solid #d6d7d9;
  display: flex;
  justify-content: center;
  align-self: stretch;
`;

export const ContactSalesSection = styled.div`
  padding: ${spacing.small};
  text-align: center;
`;
